module.exports = __webpack_public_path__ + "img/Frame4.e9addd20.svg";